(function ($) {
	$.fn.toggleIconClass = function (orgClassIcon, nextClassIcon) {
		if (this.hasClass('icon')) {
			if (this.hasClass(orgClassIcon)) {
				this.replaceClass(orgClassIcon, nextClassIcon);
			} else {
				this.replaceClass(nextClassIcon, orgClassIcon);
			}
		}
		return this;
	};
}(jQuery));